import { ProjectsPageContainer } from 'domains/projects/screens/ProjectsPage';
import { EditProjectStepPageV2Container } from 'domains/projects/screens/ProjectFlowPageV2/EditProjectStepPageV2Container';
import { projectsV2RoutesConfig } from 'domains/projects/routes/projectsV2Routes';

const { useParams } = projectsV2RoutesConfig.editProject;

export const EditProjectParamsResolver = () => {
  const { projectIndex } = useParams();

  if (projectIndex !== undefined) {
    return <EditProjectStepPageV2Container />;
  }

  return <ProjectsPageContainer />;
};
